/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateReferralDocumentExportRequestDocumentsInner } from './CreateReferralDocumentExportRequestDocumentsInner';
import {
    CreateReferralDocumentExportRequestDocumentsInnerFromJSON,
    CreateReferralDocumentExportRequestDocumentsInnerFromJSONTyped,
    CreateReferralDocumentExportRequestDocumentsInnerToJSON,
    CreateReferralDocumentExportRequestDocumentsInnerToJSONTyped,
} from './CreateReferralDocumentExportRequestDocumentsInner';

/**
 * 
 * @export
 * @interface CreateReferralDocumentExportRequest
 */
export interface CreateReferralDocumentExportRequest {
    /**
     * 
     */
    format: CreateReferralDocumentExportRequestFormatEnum;
    /**
     * 
     */
    documents: Array<CreateReferralDocumentExportRequestDocumentsInner>;
}


/**
 * @export
 */
export const CreateReferralDocumentExportRequestFormatEnum = {
    Pdf: 'pdf',
    Zip: 'zip',
} as const;
export type CreateReferralDocumentExportRequestFormatEnum = typeof CreateReferralDocumentExportRequestFormatEnum[keyof typeof CreateReferralDocumentExportRequestFormatEnum];


/**
 * Check if a given object implements the CreateReferralDocumentExportRequest interface.
 */
export function instanceOfCreateReferralDocumentExportRequest(value: object): value is CreateReferralDocumentExportRequest {
    if (!('format' in value) || value['format'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function CreateReferralDocumentExportRequestFromJSON(json: any): CreateReferralDocumentExportRequest {
    return CreateReferralDocumentExportRequestFromJSONTyped(json, false);
}

export function CreateReferralDocumentExportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralDocumentExportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'format': json['format'],
        'documents': ((json['documents'] as Array<any>).map(CreateReferralDocumentExportRequestDocumentsInnerFromJSON)),
    };
}

export function CreateReferralDocumentExportRequestToJSON(json: any): CreateReferralDocumentExportRequest {
    return CreateReferralDocumentExportRequestToJSONTyped(json, false);
}

export function CreateReferralDocumentExportRequestToJSONTyped(value?: CreateReferralDocumentExportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'format': value['format'],
        'documents': ((value['documents'] as Array<any>).map(CreateReferralDocumentExportRequestDocumentsInnerToJSON)),
    };
}

